import React from "react";

/**
 * "Powered by immiMentor" mark shown next to the Blift logo, matching the
 * lockup used on the marketing website.
 */
const PoweredByImmimentor: React.FC = () => (
    <span className="powered-by-immimentor">
        <span className="powered-by-label">Powered by</span>
        <span className="powered-by-mark" role="img" aria-label="ImmiMentor" title="ImmiMentor"/>
    </span>
);

export default PoweredByImmimentor;
